import { BRIK_STATUS } from "./../../utils/index";
import BrikServices from "services/brik.services";
import { actions } from "./actionTypes";
import { alertActions } from "actions/alert.actions";
import AppHelper from "helpers/AppHelper";

export const createBrik = (params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.createBrik());
    return await BrikServices.createBrik(params)
      .then((res: any) => {
        // const itemsPerPage = 12;
        // const page = 1;
        const renderTypeName = () => {
          switch (params.type_name) {
            case 0:
              return "lesson";
            case 1:
              return "program";
            case 2:
              return "challenge";
          }
        };
        dispatch(actions.createBrikSuccess(res?.data));
        // dispatch(getListBrik(page, itemsPerPage, LIST_FILTER[0].value));
        dispatch(
          alertActions.success(
            `A new ${renderTypeName()} has been created successfully!`
          )
        );
        return res.data;
      })
      .catch((err) => {
        dispatch(alertActions.error("An error occurred. Please try again"));
        dispatch(actions.createBrikFail(err));
      });
  };
};

export const updateBrik = (
  id: any,
  params: any,
  isFromDetail: boolean,
  typeName?: any
) => {
  return (dispatch: any) => {
    dispatch(actions.updateBrik());
    BrikServices.updateBrik(id, params)
      .then((res: any) => {
        dispatch(actions.updateBrikSuccess(res?.data));
        if (isFromDetail) {
          dispatch(getBrikDetail(id));
        }
        AppHelper.hideGlobalModal();
        const renderTypeName = () => {
          switch (typeName) {
            case 0:
              return "Lesson";
            case 1:
              return "Program";
            case 2:
              return "Challenge";
          }
        };
        dispatch(
          alertActions.success(
            renderTypeName()
              ? `${renderTypeName()} has been edited!`
              : "Success"
          )
        );
      })
      .catch((err) => {
        console.error("UpdateBrik Error Details:", err);
        dispatch(actions.updateBrikFail(err));
        
        // Show more specific error message if available
        let errorMessage = "An error occurred. Please try again";
        if (err?.message) {
          errorMessage = err.message;
        } else if (err?.error) {
          errorMessage = err.error;
        } else if (typeof err === 'string') {
          errorMessage = err;
        }
        
        dispatch(alertActions.error(errorMessage));
      });
  };
};

export const updateBrikShowTableMode = (id: any, showTableMode: number) => {
  return (dispatch: any) => {
    dispatch(actions.updateBrik());
    const params = { show_table_mode: showTableMode };
    BrikServices.updateBrik(id, params)
      .then((res: any) => {
        dispatch(actions.updateBrikSuccess(res?.data));
        console.log("res?.data: ", res?.data);
        dispatch(alertActions.success(`Show table mode updated successfully!`));
      })
      .catch((err) => {
        dispatch(actions.updateBrikFail(err));
      });
  };
};

export const getListBrik = (
  page: number,
  limit: number,
  type: number,
  name: string = ""
) => {
  return (dispatch: any) => {
    dispatch(actions.getListBrik());
    BrikServices.getListBrik({ page, limit, type, name })
      .then((res: any) => {
        dispatch(actions.getListBrikSuccess(res?.data, type));
      })
      .catch((err) => {
        dispatch(actions.getListBrikFail(err));
      });
  };
};

export const createSection = (id: any, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.createSection());
    return await BrikServices.createSection(id, params)
      .then((res: any) => {
        return dispatch(actions.createSectionSuccess(res?.data));
      })
      .catch((err) => {
        return dispatch(actions.createSectionFail(err));
      });
  };
};

export const createLength = (id: any, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.createLength());
    return await BrikServices.createLength(id, params)
      .then((res: any) => {
        return dispatch(actions.createLengthSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(alertActions.error("Error !"));
        return dispatch(actions.createLengthFail(err));
      });
  };
};

export const createDay = (brik_id: string, week_id: string, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.createDay());
    return await BrikServices.createDay(brik_id, week_id, params)
      .then((res: any) => {
        return dispatch(actions.createDaySuccess(res?.data));
      })
      .catch((err) => {
        dispatch(alertActions.error("Error !"));
        dispatch(actions.createDayFail(err));
      });
  };
};

export const createSubSection = (
  brik_id: string,
  section_id: string,
  params: any,
  subsection_id?: any
) => {
  return async (dispatch: any) => {
    dispatch(actions.createSubSection());
    await BrikServices.createSubSection(
      brik_id,
      section_id,
      params,
      subsection_id
    )
      .then((res: any) => {
        dispatch(actions.createSubSectionSuccess(res?.data));
      })
      .catch((err) => {
        if (err?.message?.name?.[0] === "validation.max.string") {
          dispatch(
            alertActions.error("You can't enter more than 10240 characters.")
          );
        }
        dispatch(actions.createSubSectionFail(err));
      });
  };
};

export const updateSubSection = (
  brik_id: string,
  section_id: string,
  sub_id: string,
  params: any
) => {
  return async (dispatch: any) => {
    dispatch(actions.createSubSection()); // Reuse the same action type
    await BrikServices.createSubSection(brik_id, section_id, params, sub_id)
      .then((res: any) => {
        dispatch(actions.createSubSectionSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.createSubSectionFail(err));
      });
  };
};

export const orderSubSection = (
  brik_id: string,
  section_id: string,
  params: any
) => {
  return async (dispatch: any) => {
    dispatch(actions.orderSubSection());
    await BrikServices.orderSubSection(brik_id, section_id, params)
      .then((res: any) => {
        dispatch(actions.orderSubSectionSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.orderSubSectionFail(err));
      });
  };
};

export const deleteSubSection = (
  brik_id: string,
  section_id: string,
  sub_id: any
) => {
  return async (dispatch: any) => {
    dispatch(actions.deleteSubSection());
    await BrikServices.deleteSubSection(brik_id, section_id, sub_id)
      .then((res: any) => {
        dispatch(actions.deleteSubSectionSuccess(res));
      })
      .catch((err) => {
        dispatch(actions.deleteSubSectionFail(err));
      });
  };
};

export const getBrikDetail = (brik_id: string) => {
  return async (dispatch: any) => {
    dispatch(actions.getBrikDetail());
    return await BrikServices.getBrikDetail(brik_id)
      .then((res: any) => {
        return dispatch(actions.getBrikDetailSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(alertActions.error("Error !"));
        return dispatch(actions.getBrikDetailFail(err));
      });
  };
};

export const getListSection = (
  brik_id: string,
  length_id?: string,
  day_id?: string
) => {
  return async (dispatch: any) => {
    dispatch(actions.getListSection());
    return await BrikServices.getListSection(brik_id, { length_id, day_id })
      .then((res: any) => {
        return dispatch(actions.getListSectionSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(alertActions.error("Error !"));
        return dispatch(actions.getListSectionFail(err));
      });
  };
};

export const getNameSubSection = () => {
  return async (dispatch: any) => {
    dispatch(actions.getNameSubSection());
    return await BrikServices.getNameSubSection()
      .then((res: any) => {
        return dispatch(actions.getNameSubSectionSuccess(res?.data));
      })
      .catch((err) => {
        return dispatch(actions.getNameSubSectionFail(err));
      });
  };
};

export const updateSection = (
  brik_id: string,
  section_id: string,
  params: any
) => {
  return async (dispatch: any) => {
    dispatch(actions.updateSection());
    return await BrikServices.updateSection(brik_id, section_id, params)
      .then((res: any) => {
        return dispatch(actions.updateSectionSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(alertActions.error("Error !"));
        dispatch(actions.updateSectionFail(err));
      });
  };
};

export const orderSection = (brik_id: string, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.orderSection());
    return await BrikServices.orderSection(brik_id, params)
      .then((res: any) => {
        return dispatch(actions.orderSectionSuccess(res?.data));
      })
      .catch((err) => {
        return dispatch(actions.orderSectionFail(err));
      });
  };
};

export const createContent = (
  brik_id: string,
  section_id: string,
  sub_id: string,
  params: any
) => {
  return async (dispatch: any) => {
    dispatch(actions.createContent());
    await BrikServices.createContent(brik_id, section_id, sub_id, params)
      .then((res: any) => {
        dispatch(actions.createContentSuccess(res));
      })
      .catch((err) => {
        dispatch(alertActions.error("Error !"));
        dispatch(actions.createContentFail(err));
      });
  };
};

export const updateContent = (
  brik_id: string,
  section_id: string,
  sub_id: string,
  content_id: string,
  params: any
) => {
  return async (dispatch: any) => {
    dispatch(actions.updateContent());
    return await BrikServices.updateContent(
      brik_id,
      section_id,
      sub_id,
      content_id,
      params
    )
      .then((res: any) => {
        return dispatch(actions.updateContentSuccess(res));
      })
      .catch((err) => {
        dispatch(alertActions.error("Error !"));
        dispatch(actions.updateContentFail(err));
      });
  };
};

export const orderContent = (
  brik_id: string,
  section_id: string,
  sub_id: string,
  params: any
) => {
  return async (dispatch: any) => {
    dispatch(actions.orderContent());
    await BrikServices.orderContent(brik_id, section_id, sub_id, params)
      .then((res: any) => {
        dispatch(actions.orderContentSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.orderContentFail(err));
      });
  };
};

export const deleteSection = (brik_id: string, section_id: string) => {
  return async (dispatch: any) => {
    dispatch(actions.deleteSection());
    await BrikServices.deleteSection(brik_id, section_id)
      .then((res: any) => {
        dispatch(actions.deleteSectionSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(alertActions.error("Error !"));
        dispatch(actions.deleteSectionFail(err));
      });
  };
};

export const deleteContent = (
  brik_id: string,
  section_id: string,
  sub_id: string,
  content_id: string
) => {
  return async (dispatch: any) => {
    dispatch(actions.deleteContent());
    await BrikServices.deleteContent(brik_id, section_id, sub_id, content_id)
      .then((res: any) => {
        dispatch(actions.deleteContentSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.deleteContentFail(err));
      });
  };
};

export const duplicateBrik = (brik_id: string, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.duplicateBrik());
    await BrikServices.duplicateBrik(brik_id, params)
      .then((res: any) => {
        dispatch(actions.duplicateBrikSuccess(res?.data));
        dispatch(alertActions.success("Successfully duplicated!"));
      })
      .catch((err) => {
        dispatch(actions.duplicateBrikFail(err));
        dispatch(alertActions.error("Error !"));
      });
  };
};

export const duplicateSection = (
  brik_id: string,
  section_id: string,
  params: any
) => {
  return async (dispatch: any) => {
    dispatch(actions.duplicateSection());
    return await BrikServices.duplicateSection(brik_id, section_id, params)
      .then((res: any) => {
        dispatch(alertActions.success("Successfully duplicated!"));
        return dispatch(actions.duplicateSectionSuccess(res?.data));
      })
      .catch((err) => {
        console.error('duplicateSection API error:', err);
        dispatch(actions.duplicateSectionFail(err));
        dispatch(alertActions.error("Error !"));
      });
  };
};

export const shareBrik = (brik_id: string, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.shareBrik());
    await BrikServices.shareBrik(brik_id, params)
      .then((res: any) => {
        dispatch(actions.shareBrikSuccess(res?.data));
        dispatch(alertActions.success("Brik is shared successfully!"));
      })
      .catch((err) => {
        dispatch(actions.shareBrikFail(err));
        dispatch(alertActions.error("Error !"));
      });
  };
};

export const getListShare = (brik_id: string, search: string) => {
  return async (dispatch: any) => {
    dispatch(actions.getListShare());
    return await BrikServices.getListShare(brik_id, { search })
      .then((res: any) => {
        return dispatch(actions.getListShareSuccess(res?.data));
      })
      .catch((err) => {
        // dispatch(alertActions.error('Error !'));
        dispatch(actions.getListShareFail(err));
      });
  };
};

export const deleteBrik = (brik_id: string, typeName?: any) => {
  return async (dispatch: any) => {
    dispatch(actions.deleteBrik());
    await BrikServices.deleteBrik(brik_id)
      .then((res: any) => {
        const renderTypeName = () => {
          switch (typeName) {
            case 0:
              return "Lesson";
            case 1:
              return "Program";
            case 2:
              return "Challenge";
          }
        };
        dispatch(actions.deleteBrikSuccess(brik_id));
        dispatch(
          alertActions.success(
            renderTypeName()
              ? `${renderTypeName()} has been deleted!`
              : "Success"
          )
        );
      })
      .catch((err) => {
        dispatch(actions.deleteBrikFail(err));
        dispatch(alertActions.error(err?.message?.toString()));
      });
  };
};

export const deleteLength = (brik_id: string, length_id: string) => {
  return async (dispatch: any) => {
    dispatch(actions.deleteLength());
    return await BrikServices.deleteLength(brik_id, length_id)
      .then((res: any) => {
        return dispatch(actions.deleteLengthSuccess(res?.data));
        // dispatch(alertActions.success('Success'));
      })
      .catch((err) => {
        dispatch(actions.deleteLengthFail(err));
        dispatch(alertActions.error("Error !"));
      });
  };
};

export const deleteDay = (
  brik_id: string,
  length_id: string,
  day_id: string
) => {
  return async (dispatch: any) => {
    dispatch(actions.deleteDay());
    return await BrikServices.deleteDay(brik_id, length_id, day_id)
      .then((res: any) => {
        // dispatch(alertActions.success('Success'));
        return dispatch(actions.deleteDaySuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.deleteDayFail(err));
        dispatch(alertActions.error("Error !"));
      });
  };
};

export const changeBrikStatus = (brik_id: string) => {
  return async (dispatch: any) => {
    await BrikServices.changeStatus(brik_id)
      .then((res: any) => {
        dispatch(actions.changeBrikStatusSuccess(res?.data));
        if (res?.data?.status === BRIK_STATUS.LIVE) {
          dispatch(alertActions.success(`Brik is now LIVE!`));
        }
        if (res?.data?.status === BRIK_STATUS.HIDDEN) {
          dispatch(alertActions.success(`Brik is now hidden!`));
        }
      })
      .catch((err) => {
        dispatch(actions.changeBrikStatusFail());
        dispatch(alertActions.error(err?.message));
      });
  };
};

export const duplicateLength = (brik_id: string, length_id: string) => {
  return async (dispatch: any) => {
    dispatch(actions.duplicateLength());
    return await BrikServices.duplicateLength(brik_id, length_id)
      .then((res: any) => {
        // dispatch(alertActions.success('Successfully duplicated!'));
        return dispatch(actions.duplicateLengthSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.duplicateLengthFail(err));
        dispatch(alertActions.error("Error !"));
      });
  };
};

export const duplicateDay = (
  brik_id: string,
  length_id: string,
  day_id: string,
  params: any
) => {
  return async (dispatch: any) => {
    dispatch(actions.duplicateDay());
    return await BrikServices.duplicateDay(brik_id, length_id, day_id, params)
      .then((res: any) => {
        // dispatch(alertActions.success('Successfully duplicated!'));
        return dispatch(actions.duplicateDaySuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.duplicateDayFail(err));
        dispatch(alertActions.error("Error !"));
      });
  };
};

export const listSharedData = (brik_id: string) => {
  return async (dispatch: any) => {
    dispatch(actions.listSharedData());
    return await BrikServices.listSharedData(brik_id)
      .then((res: any) => {
        return dispatch(actions.listSharedDataSuccess(res?.data));
      })
      .catch((err) => {
        // dispatch(alertActions.error('Error !'));
        dispatch(actions.listSharedDataFail(err));
      });
  };
};

export const unshareBrik = (brik_id: string, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.unshareBrik());
    return await BrikServices.unshareBrik(brik_id, params)
      .then((res: any) => {
        return dispatch(actions.unshareBrikSuccess(res?.data));
      })
      .catch((err) => {
        // dispatch(alertActions.error('Error !'));
        dispatch(actions.unshareBrikFail(err));
      });
  };
};

export const deleteAllSubSection = (
  brik_id: string,
  section_id: string,
  day_id: string
) => {
  return async (dispatch: any) => {
    dispatch(actions.deleteAllSubSection());
    await BrikServices.deleteAllSubSection(brik_id, section_id, day_id)
      .then((res: any) => {
        dispatch(actions.deleteAllSubSectionSuccess());
      })
      .catch((err) => {
        dispatch(alertActions.error("Error !"));
        dispatch(actions.deleteAllSubSectionFail(err));
      });
  };
};

export const deleteDayAllSubSection = (brik_id: string, section_id: string) => {
  return async (dispatch: any) => {
    dispatch(actions.deleteDayAllSubSection());
    await BrikServices.deleteDayAllSubSection(brik_id, section_id)
      .then((res: any) => {
        dispatch(actions.deleteDayAllSubSectionSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(alertActions.error("Error !"));
        dispatch(actions.deleteDayAllSubSectionFail(err));
      });
  };
};

export const orderLength = (brik_id: string, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.orderLength());
    await BrikServices.orderLength(brik_id, params)
      .then((res: any) => {
        dispatch(actions.orderLengthSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(alertActions.error("Error !"));
        dispatch(actions.orderLengthFail(err));
      });
  };
};

export const orderDays = (brik_id: string, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.orderDays());
    return await BrikServices.orderDays(brik_id, params)
      .then((res: any) => {
        return dispatch(actions.orderDaysSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(alertActions.error("Error !"));
        return dispatch(actions.orderDaysFail(err));
      });
  };
};

export const dragBrik = (
  brik_id: string,
  sectionId: string,
  params: { day_id: number; week_id: number; order: number }
) => {
  return async (dispatch: any) => {
    dispatch(actions.dragBrik());
    return await BrikServices.dragBrik(brik_id, sectionId, params)
      .then((res: any) => {
        return dispatch(actions.dragBrikSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(
          alertActions.error(
            "Something expected happened while changing your Brik position !"
          )
        );
        return dispatch(actions.dragBrikFail(err));
      });
  };
};
